<template>
  <v-row dense>
    <v-col cols="12 mb-2">
      <BTextarea
        v-model="form.name"
        :disabled="disabled"
        rows="1"
        validate="required"
        label="Название"
        name="name"
        autofocus
      />
    </v-col>

    <v-col v-if="false" cols>
      <BTextField
        v-model.number="form.min_events_count"
        :disabled="disabled"
        validate="required|numeric|min_value:1"
        label="Минимальное кол-во Мер"
        type="number"
        name="min_events_count"
        class="mr-6"
      />
    </v-col>

    <v-col cols="auto" align-self="center">
      <v-checkbox
        v-model="form.is_required"
        :disabled="disabled"
        label="Обязательно?"
        dense
        name="is_required"
        hide-details
        class="mt-0"
      />
    </v-col>
  </v-row>
</template>

<script>
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'


export const createDefaultData = () => ({
  // id
  name: '',
  position: 0,
  events: [],
  min_events_count: 1,
  events_count: 0,
  is_required: false,
})

export default {
  name: 'RoadmapDirectionsForm',
  components: {
    BTextField,
    BTextarea,
  },
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>
